import { faMars, faVenus } from '@fortawesome/free-solid-svg-icons';
import { useMemo } from 'react';

import type { RecordClientSearchResult } from '@app/components/RecordModal/components/RecordDetails/types';
import {
  formatAge,
  formatDate,
} from '@app/components/RecordModal/components/RecordDetails/utils';

// Данные строки найденного клиента: имя, значок пола, дата рождения и
// возраст.
export const useClientSearchOption = (client: RecordClientSearchResult) =>
  useMemo(() => {
    const fullName = `${client.NameLast || ''} ${
      client.NameFirst || ''
    }`.trim();
    const isMale = client.Gender === 'm';
    const isFemale = client.Gender === 'f';
    const dateBirth = formatDate(client.DateBirth ?? null);
    const age = formatAge(client.Age);

    return {
      name: fullName || `Клиент #${client.Id}`,
      genderIcon: isMale ? faMars : isFemale ? faVenus : null,
      isMale,
      isFemale,
      birthInfo: [dateBirth, age].filter(Boolean).join(' '),
    };
  }, [client]);
